<template>
  <div id="email-form">
    <div class="input-container">
      <label for="email">{{$t("ideas.top.email.form.email")}}</label>
      <input
      type="email"
      name="email"
      id="email"
      :placeholder="$t('ideas.top.email.form.email_ph')"
      v-model="$v.form.email.$model">
      <div v-if="$v.$error" class="error-msg">
        <p v-if="!$v.form.email.required">{{$t("ideas.top.email.errors.email_required")}}</p>
        <p v-if="!$v.form.email.email">{{$t("ideas.top.email.errors.email_valid")}}</p>
      </div>
    </div>
    <button
    class="update-btn"
    @click="validateForm">
      {{$t("ideas.top.email.form.update")}}
    </button>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import API_SERVICE from "@/lib/api/Ideas.js";
const api = new API_SERVICE();

export default {
  data: function() {
    return {
      form: {
        email: null
      }
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      }
    }
  },
  beforeMount: async function() {
    await this.getEmail();
  },
  methods: {
    getEmail: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.getEmail();
        this.form.email = resp.title;
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    validateForm: async function() {
      this.$v.$touch();
      if (this.$v.$error) return;
      this.updateEmail();
    },
    updateEmail: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        await api.saveEmail(this.form.email);
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#email-form { 
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 2rem 0;
}
.input-container {
  @extend %audi;
  margin-right: 2rem;
  display: flex;
  flex-direction: column;
  font-size: 16px;
}
.input-container > label {
  @extend %audi-b;
}
.update-btn {
  @extend %audi;
  color: $black;
  background-color: transparent;
  border: 1px solid $black;
  padding: 5px 10px;
}
.error-msg {
  color: $warn_red;
  font-size: 14px;
}
.error-msg > p {
  margin: 0;
}
</style>